// start:ng42.barrel
export * from './write-review.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/write-review/write-review/index.ts